(function () {
  var form = document.querySelector(".product-form__form");
  if (!form) return;
  var radios = form.querySelectorAll('input[name="purchase_option"]');
  var wrap = document.getElementById("PlanWrap");
  var select = document.getElementById("SellingPlan");

  function updateUI() {
    var subscribe =
      form.querySelector('input[name="purchase_option"]:checked') &&
      form.querySelector('input[name="purchase_option"]:checked').value ===
        "subscribe";
    if (subscribe) {
      wrap.style.height = wrap.scrollHeight + 1 + "px";
      if (!select.name) select.name = "selling_plan"; // now the plan will be submitted
      select.disabled = false;
    } else {
      wrap.style.height = 0 + "px";

      if (select.name) select.removeAttribute("name"); // omit from submit → one-time purchase
      select.disabled = true;
    }
  }

  // init + listeners
  updateUI();
  radios.forEach((r) => r.addEventListener("change", updateUI));

  const cartNudge = document.querySelector(".fixedCartNudgeCtn");
  const pdpBtn = document.querySelector(".pdpBtn");
  let allowed = false;

  const nudgeObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          allowed = true;
          cartNudge.classList.remove("active");
        } else if (allowed) {
          cartNudge.classList.add("active");
        }
      });
    },
    { threshold: 0.1 }
  );

  nudgeObserver.observe(pdpBtn);
})();
